import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Legal = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-background/80 border-b border-border">
        <div className="container mx-auto px-4 h-16 flex items-center gap-4">
          <Button variant="ghost" size="icon" onClick={() => navigate(-1)}>
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <h1 className="text-xl font-semibold">Mentions Légales</h1>
        </div>
      </header>

      <main className="container mx-auto px-4 py-12 max-w-3xl">
        <article className="prose prose-slate max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">1. Éditeur du site</h2>
            <div className="text-muted-foreground leading-relaxed space-y-2">
              <p><strong>Raison sociale :</strong> EasyFinder SAS</p>
              <p><strong>Siège social :</strong> 123 Avenue de l'Innovation, 75001 Paris, France</p>
              <p><strong>Capital social :</strong> 10 000 €</p>
              <p><strong>RCS :</strong> Paris B 123 456 789</p>
              <p><strong>SIRET :</strong> 123 456 789 00012</p>
              <p><strong>TVA intracommunautaire :</strong> FR 12 123456789</p>
              <p><strong>Directeur de la publication :</strong> [Nom du dirigeant]</p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">2. Contact</h2>
            <div className="text-muted-foreground leading-relaxed space-y-2">
              <p><strong>Email :</strong> <a href="mailto:contact@easyfinder.fr" className="text-primary hover:underline">contact@easyfinder.fr</a></p>
              <p><strong>Téléphone :</strong> +33 1 23 45 67 89</p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">3. Hébergement</h2>
            <div className="text-muted-foreground leading-relaxed space-y-2">
              <p><strong>Hébergeur :</strong> Supabase Inc.</p>
              <p><strong>Adresse :</strong> 970 Toa Payoh North, Singapore 318992</p>
              <p><strong>Site web :</strong> <a href="https://supabase.com" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">https://supabase.com</a></p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">4. Propriété intellectuelle</h2>
            <p className="text-muted-foreground leading-relaxed">
              L'ensemble du contenu de ce site (textes, images, logos, icônes, code source) est protégé 
              par le droit d'auteur et le droit des marques. Toute reproduction, représentation, modification, 
              publication ou adaptation de tout ou partie des éléments du site est interdite sans 
              autorisation écrite préalable de EasyFinder SAS.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">5. Données personnelles</h2>
            <p className="text-muted-foreground leading-relaxed">
              Conformément à la loi Informatique et Libertés du 6 janvier 1978 modifiée et au Règlement 
              Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification, 
              de suppression et de portabilité de vos données personnelles. Pour plus d'informations, 
              consultez notre <a href="/privacy" className="text-primary hover:underline">Politique de Confidentialité</a>.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">6. Délégué à la Protection des Données (DPO)</h2>
            <div className="text-muted-foreground leading-relaxed space-y-2">
              <p>Pour toute question relative à la protection de vos données personnelles :</p>
              <p><strong>Email :</strong> <a href="mailto:dpo@easyfinder.fr" className="text-primary hover:underline">dpo@easyfinder.fr</a></p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">7. Cookies</h2>
            <p className="text-muted-foreground leading-relaxed">
              Ce site utilise des cookies nécessaires à son bon fonctionnement. Ces cookies techniques 
              ne nécessitent pas votre consentement. Aucun cookie publicitaire ou de traçage n'est utilisé.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">8. Médiation</h2>
            <p className="text-muted-foreground leading-relaxed">
              Conformément à l'article L.616-1 du Code de la consommation, en cas de litige, vous pouvez 
              recourir gratuitement au service de médiation. Médiateur de la consommation : 
              [Nom du médiateur] - [Adresse du médiateur]
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">9. Droit applicable</h2>
            <p className="text-muted-foreground leading-relaxed">
              Les présentes mentions légales sont régies par le droit français. Tout litige relatif 
              à l'utilisation du site sera soumis à la compétence exclusive des tribunaux de Paris.
            </p>
          </section>
        </article>
      </main>
    </div>
  );
};

export default Legal;
